/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";

export const GET_USER_LIST_DELEGATE = gql`
  query GetBoxes($filter: BoxFilterInput, $options: GetManyOptions) {
    getBoxes(filter: $filter, options: $options) {
      content {
        _id
        user {
          vuid
          email
          firstName
          lastName
          accountStatus
          suspended
          gender
          role {
            name
            uuid
            state
          }
          inviteStatus
        }
        delegateName
        costumeID
        boxStatus
        blockedDelegate
      }
      limit
      skip
      count
    }
  }
`;

// $input: RoleListInput

// getListOfRole(input: $input) {
//   totalCount
//   data
// }
